/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение</h2>
    <p className={styles.description}>
      Когда проект достаточно большой или над проектом работает не один специалист, а группа, то возникает вопрос - где
      и как хранить код, как получать из хранилища самую актуальную версию, и как отыскать старую версию, если она вдруг
      понадобиться. Именно для решения этих вопросов (а также множество других, не менее важных) существуют системы
      контроля версий. Данные системы позволяют нескольким разработчикам параллельно работать над одним проектом,
      обеспечивая, при этом, гарантию того, что не один из разработчиков не удалит код другого.
    </p>
    <p className={styles.description}>
      <b>Система контроля версий</b> — это программа, позволяющая разработчикам проекта отслеживать и записывать
      изменения, вносимые всеми участниками в файлы этого проекта. Результат может быть объединен в один файл или разбит
      на множество файлов - все равно вклад каждого участника, история его записей будет сохранена. На сегодня одной из
      самых распространенных систем контроля версий является Git.
    </p>
    <p className={styles.description}>
      Так как данный курс берет на себя задачу обучения верстке, git является вспомогательным инструментом для
      автоматизации и удобства процесса сдачи домашних заданий. Мы рассмотрим ключевые моменты и понятия Git достаточные
      для удобной работы с курсом.
    </p>
    <p className={styles.notificationWarn}>
      Рекомендуем ознакомиться с исчерпывающим{' '}
      <a
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.atlassian.com/git/tutorials/what-is-version-control"
      >
        учебником по Git от Atlassian
      </a>{' '}
      в свободное от курса время. Также в дополнительных материалах есть видеокурс по{' '}
      <code className={styles.code}>git</code> на русском.
    </p>

    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Git</h3>
      <p className={styles.description}>
        <a className={styles.link} target="_blank" rel="noopener noreferrer" href="https://git-scm.com/">
          Git (Гит)
        </a>{' '}
        — система контроля и управления версиями файлов. Технология организации системы контроля версий достаточно
        специфична и в чем-то отдаленно похожа на хранение файлов на сервисе Google Drive с тем отличием, что все
        изменения и версии файлов фиксируются, и для работы используется специальная программа или терминал.
      </p>
    </section>

    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.2 - GitHub</h3>
      <p className={styles.description}>
        <a className={styles.link} target="_blank" rel="noopener noreferrer" href="https://github.com/">
          GitHub (Гитхаб)
        </a>{' '}
        — веб-сервис для размещения репозиториев и совместной разработки проектов. Работает по принципам Git и является
        хостингом IT-проектов. Предоставляет весь необходимый функционал для работы Git. Существуют и другие подобные
        сервисы, например - GitLab и BitBucket.
      </p>
    </section>

    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.3 - Репозиторий</h3>
      <p className={styles.description}>
        <b>Репозиторий (Repository)</b> — каталог файловой системы, в котором находятся: файлы конфигурации, файлы
        журналов операций выполняемых в репозитории, индекс расположения файлов и хранилище, содержащее сами
        контролируемые версии файлов.
      </p>
      <section className={styles.subsection}>
        <h4 className={styles.h4}>1.3.1 - Типы репозиториев</h4>
        <ul className={styles.list}>
          <li className={styles.list__item}>
            <code className={styles.code}>Локальный репозиторий</code> - репозиторий, расположенный на локальном
            компьютере разработчика в каталоге. Именно в нём происходит разработка и фиксация изменений, которые
            отправляются на удалённый репозиторий.
          </li>
          <li className={styles.list__item}>
            <code className={styles.code}>Удалённый репозиторий</code> - репозиторий, находящийся на удалённом сервере.
            Это общий репозиторий, в который приходят все изменения и из которого забираются все обновления.
            Предоставляет возможность совместной работы над проектом.
          </li>
        </ul>
      </section>
    </section>
  </section>
))
